import { Resource, Encounter } from '@medplum/fhirtypes'
import { formatDateTime } from '@/utils'

type Props = {
  resource?: Resource
}

const availFields = [
  { code: 'type', title: 'Type', width: '30%' },
  { code: 'date', title: 'Date', width: '130px' },
  { code: 'status', title: 'Status' },
  { code: 'performer', title: 'Performer' },
  { code: 'location', title: 'Location' },
  { code: 'indication', title: 'Indication' },
]

const renderColumn = (resource: Encounter, itemCode: string) => {
  switch (itemCode) {
    case 'type': {
      const types: string[] = []

      if (resource.class.display && resource.class.display.toLowerCase() !== 'unknown') {
        const type =
          resource.class.display.charAt(0).toUpperCase() + resource.class.display.slice(1)
        types.push(type)
      }

      for (const t of resource.type || []) {
        if (t.text && !types.includes(t.text)) types.push(t.text)
      }
      return types.join('\n') || ''
    }
    case 'date':
      return resource.period?.start ? formatDateTime(resource.period.start) : ''
    case 'status':
      return resource.status || ''
    case 'performer': {
      let performer = ''
      const performers = []
      const ext = resource.extension?.find((e) => e.url?.match(/record-recorder/))

      if (ext?.valueReference?.display) {
        performer = ext.valueReference.display
        performers.push(ext.valueReference.display)
      }

      const primaryParticipant = resource.participant?.find((p) =>
        p.type?.find((t) => t.text === 'primary performer'),
      )

      if (primaryParticipant?.individual?.display) {
        if (!performers.includes(primaryParticipant.individual.display)) {
          performers.push(primaryParticipant.individual.display)
        }
      } else {
        const participant = resource.participant?.find((p) => p.individual?.display)
        if (participant?.individual?.display) {
          if (!performers.includes(participant.individual.display)) {
            performer += `\n${participant.individual.display}`
            performers.push(participant.individual.display)
          }
        }
      }

      const provenances =
        resource.contained?.filter((item) => item.resourceType === 'Provenance') || []

      for (const provenance of provenances) {
        const agent = provenance.agent?.find((a) =>
          a.type?.coding?.find((t) => t.code === 'source'),
        )

        if (agent?.who?.display && !performers.includes(agent?.who?.display)) {
          performer += `\n${agent.who.display}`
          performers.push(agent.who.display)
        }
      }

      return performer
    }
    case 'location': {
      const location = resource.contained?.filter((i) => i.resourceType === 'Location') || []

      let locationDisplay = ''

      for (const loc of location) {
        locationDisplay = loc.name || 'Unknown Location'

        if (loc.address?.text) {
          locationDisplay += `\n${loc.address.text}`
        }
      }
      return locationDisplay || resource.location?.[0]?.location?.display || ''
    }
    case 'indication':
      return resource.reasonCode?.[0]?.coding?.[0]?.display || ''

    default:
      return ''
  }
}

export function Encounters({ resource }: Props) {
  const encounter = resource as Encounter

  if (!encounter) {
    return null
  }

  return (
    <div className="border-b-1 border-b-gray-200 pb-2">
      <table className="text-base">
        <tbody>
          {' '}
          {availFields.map((item) => (
            <tr>
              <td className="py-1 text-sm font-bold text-[#7D7987]">{item.title}:</td>
              <td className="px-[8px] py-1 text-base text-sm">
                <div>{renderColumn(encounter, item.code)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
